import {
	SBGrid,
	SBBox,
	SBIconButton,
	SBIcon,
	SBActiveLinkIcon,
	SBStyledTooltip,
	SBTypography,
} from "modules/Commons";
import { useStyles } from "./style";
import { useTranslation } from "react-i18next";
import { Portal } from "@mui/core";
import SBActiveLink from "modules/Commons/SBForms/SBActiveLink";
import { useClientRules } from "hooks/useClientRules";

export default ({ onLogout }: { onLogout: () => {} }) => {
	const classes = useStyles();
	const rules = useClientRules();
	const { t } = useTranslation();

	const enabledRoutes = rules.views;

	const routes = [
		{
			name: "home",
			title: t("home"),
			to: "/home",
			icon: "home",
			children: [
				{
					name: "home",
					title: t("Home"),
					to: "/home",
				},
				{
					name: "details",
					title: t("details"),
					to: "/home/details",
				},
			]
		},
		{
			name: "purchase",
			title: t("purchase"),
			to: "/purchase/recomendation",
			icon: "shopping-cart",
			children: [
				{
					name: "recommendation",
					title: t("recommendation"),
					to: "/purchase/recomendation",
				},
				{
					name: "planning",
					title: t("planning"),
					to: "/purchase/planning",
				},
			],
		},
		{
			name: "distribution",
			title: t("distribution"),
			to: "/distribution",
			icon: "send",
			children: [
				{
					name: "distribution",
					title: t("recommendation"),
					to: "/distribution",
					icon: "send",
				},
			],
		},
		{
			name: "transference",
			title: t("transference"),
			to: "/transference",
			icon: "truck",
			children: [
				{
					name: "transference",
					title: t("recommendation"),
					to: "/transference",
					icon: "truck",
				},
			],
		},
		{
			name: "inventoryPosition",
			title: t("inventory"),
			to: "/inventory/position",
			icon: "package",
			children: [
				{
					name: "inventoryPosition",
					title: t("position"),
					to: "/inventory/position",
				},
			],
		},
		{
			name: "orders",
			title: t("orders"),
			to: "/orders/purchases",
			icon: "clipboard",
			children: [
				{
					name: "supplyOrder",
					title: t("purchase"),
					to: "/orders/purchases",
					children: [
						{
							name: "supplyOrderPending",
							title: t("supplyOrderPendingMenu"),
							to: "/orders/purchases",
						},
						{
							name: "supplyOrderReceived",
							title: t("supplyOrderReceivedMenu"),
							to: "/orders/purchases/entregues",
						},
					],
				},
				{
					name: "distributionOrder",
					title: t("distribution"),
					to: "/orders/distributions",
					children: [
						{
							name: "distributionOrderPending",
							title: t("distributionOrderPendingMenu"),
							to: "/orders/distributions",
						},
						{
							name: "distributionOrderReceived",
							title: t("distributionOrderReceivedMenu"),
							to: "/orders/distributions/entregues",
						},
					],
				},
				{
					name: "transferenceOrder",
					title: t("transference"),
					to: "/orders/transferences",
					children: [
						{
							name: "transferenceOrderPending",
							title: t("transferenceOrderPendingMenu"),
							to: "/orders/transferences",
						},
						{
							name: "transferenceOrderReceived",
							title: t("transferenceOrderReceivedMenu"),
							to: "/orders/transferences/entregues",
						},
					],
				},
			],
		},
		{
			name: "analytics",
			title: t("analytics"),
			to: "/exploration",
			icon: "activity",
			children: [
				{
					name: "explorations",
					title: t("explorations"),
					to: "/exploration",
				},
				{
					name: "simulation",
					title: t("simulation"),
					to: "/simulation",
				},
				{
					name: "productModelAnalyser",
					title: t("productModelAnalyser", "Product Model Analyser"),
					to: "/product-model-analyser",
				},
			],
		},
		{
			name: "configurations",
			title: t("config"),
			to: "/config",
			icon: "settings",
			children: [
				{
					name: "configurations",
					title: t("config"),
					to: "/config",
				},
				{
					name: "forecastModifier",
					title: t("modifier"),
					to: "/config/forecast/modifier",
				},
				{
					name: "forecastModels",
					title: t("forecastModels", "Modelos de Previsão"),
					to: "/config/forecast/models",
				},
				{
					name: "status",
					title: t("status"),
					to: "/status",
				},
			],
		},
	] as Route[];

	const filteredRoutes = routes.filter(
		(route) => enabledRoutes.indexOf(route.name) >= 0
	);

	const renderMenuItem = (item: Route) => {
		const label = (
			<SBTypography
				textTransform="capitalize"
				color="gray3.main"
				className={classes.hoverable}
			>
				{item.title}
			</SBTypography>
		);

		if (!item.children?.length) {
			return (
				<SBActiveLink key={item.name} to={item.to}>
					{label}
				</SBActiveLink>
			);
		}

		return (
			<SBStyledTooltip
				key={item.name}
				placement="right"
				className="chooseSubMenu"
				title={<SBBox py={1.5}>{item.children.map(renderMenuItem)}</SBBox>}
			>
				<SBBox>
					<SBActiveLink to={item.to}>{label}</SBActiveLink>
				</SBBox>
			</SBStyledTooltip>
		);
	};

	return (
		<Portal>
			<SBBox className={classes.leftbar}>
				<SBGrid
					container
					direction="column"
					wrap="nowrap"
					height={1}
					justifyContent="center"
				>
					{filteredRoutes.map((route, index) => (
						<SBBox
							key={route.title}
							mb={
								index === filteredRoutes.length - 1
									? "auto"
									: "0"
							}
							mt={index === 0 ? "auto" : "0"}
						>
							<SBActiveLinkIcon
								title={
									<SBBox pb={1.5}>
										<SBTypography
											mt="8px"
											mb="4px"
											fontWeight={700}
											textTransform="capitalize"
											className={classes.title}
										>
											{route.title}
										</SBTypography>
										{route.children?.length
											? route.children.map(renderMenuItem)
											: renderMenuItem(route)}
									</SBBox>
								}
								to={route.to}
								icon={route.icon}
							/>
						</SBBox>
					))}
					<SBStyledTooltip
						placement="right"
						title={
							<SBTypography
								p={1}
								variant="caption"
								textTransform="capitalize"
							>
								{t("logout")}
							</SBTypography>
						}
						style={{ marginTop: 10 }}
					>
						<SBBox>
							<SBIconButton onClick={onLogout}>
								<SBIcon icon="power" />
							</SBIconButton>
						</SBBox>
					</SBStyledTooltip>
				</SBGrid>
			</SBBox>
		</Portal>
	);
};

export interface Route {
	name: string;
	title: string;
	to: string;
	icon: string;
	children: Route[];
}
